<template>
  <header>
    <div class="header__top">
      <div class="header__container container">
        <div class="header__usps">
          <IconCheck class="icon icon--check" />
          <span>{{ $t('Within minutes in your inbox') }}</span>
        </div>

        <div class="header__lang">
          <AppCountrySwitch class="header__country-switch" />
        </div>
      </div>
    </div>

    <div class="header">
      <div class="header__container--desk container">
        <div class="header__container--mob">
          <div class="container">
            <button
              type="button"
              class="header__back"
              @click="goBack"
            >
              <IconArrowShort class="icon icon--arrow icon--arrow-left" />
              <span>{{ $t('Back') }}</span>
            </button>

            <AppLogo class="header__logo" />
          </div>
        </div>

        <div class="header__container--mob">
          <div class="container">
            <GiftcardSteps class="header__steps" />
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts" setup>
const router = useRouter()
const { public: config } = useRuntimeConfig()

const step = inject('step', 1)

const goBack = () => {
  if (step.value === 1) {
    window.location.href = config.productionDomain
  }
  else {
    router.back()
  }
}
</script>

<style src="~layers/app/components/App/Header.css" />
